<template>
	<div
		class="form"
		data-aos="fade-up"
		data-aos-duration="400"
		id="basic-form"
	>
		<div class="form-wrapper">
			<p class="section-title">{{ title }}</p>
			<p class="section-description">{{ text }}</p>

			<div class="form-group">
				<div class="select">
					<select
						id="subject"
						v-validate="'required'"
						name="Subject"
						v-model="form.subject"
					>
						<option
							selected="“selected”"
							value="default"
							disabled
							>{{ this.$translations.form.choose_option }}</option
						>
						<option
							v-for="(value, index) in dropdownArr"
							:key="index"
							:value="value"
							>{{ value }}</option
						>
					</select>

					<span class="arrow">
						<svg
							version="1.1"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 129 129"
							xmlns:xlink="http://www.w3.org/1999/xlink"
							enable-background="new 0 0 129 129"
						>
							<g>
								<path
									d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
								/>
							</g>
						</svg>
					</span>
				</div>
			</div>
			<span
				v-show="errors.has('Subject') && submitted"
				class="form-error"
				>{{ errors.first("Subject") }}</span
			>

			<textarea
				rows="8"
				id="message"
				v-model="form.message"
				:placeholder="this.$translations.form.message"
			></textarea>

			<span v-show="errors.has('name') && submitted" class="form-error">{{
				errors.first("name")
			}}</span>
			<input
				v-validate="'required'"
				id="name"
				type="text"
				name="name"
				v-model="form.name"
				:placeholder="this.$translations.form.name"
			/>

			<span
				v-show="errors.has('email') && submitted"
				class="form-error"
				>{{ errors.first("email") }}</span
			>
			<input
				v-validate="'required|email'"
				id="email"
				type="email"
				name="email"
				v-model="form.email"
				:placeholder="this.$translations.form.email"
			/>

			<input type="hidden" id="gclid_field" name="gclid_field" value="" />

			<input type="hidden" id="cid_field" name="cid" value="" />

			<div class="terms">
				<div class="checkbox-wrapper">
					<input
						v-model="agreed_terms.status"
						type="checkbox"
						name="conditions"
						id="conditions"
						@change="agreed_terms.error = false"
					/>
					<a target="_blank" :href="terms">
						{{ this.$translations.cart.terms_text }}
					</a>
				</div>
				<div
					class="form-error"
					v-if="agreed_terms.error && !agreed_terms.status"
				>
					{{ this.$translations.cart.terms_error }}
				</div>
			</div>
			<button
				:class="[
					'btn-submit',
					btnClass,
					{ 'btn-loading': loading },
					type
				]"
				@click="submit"
			>
				{{ this.$translations.form.send }}
			</button>

			<div class="form-error" v-if="error">
				{{ this.$translations.form.error }}
			</div>

			<div class="form-success" v-if="success">
				{{ this.$translations.form.post_success }}
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import VeeValidate, { Validator } from "vee-validate";
import axios from "axios";

Vue.use(VeeValidate);

export default {
	props: {
		dropdown: { required: true, default: String },
		title: { required: true, default: String },
		text: { required: true, default: String },
		terms: { type: String, required: false },
		type: { required: false, type: String }
	},
	data() {
		return {
			form: {
				url: window.location.href,
				subject: "default",
				message: "",
				name: "",
				email: "",
				agreed: ""
			},
			loading: false,
			error: false,
			submitted: false,
			success: false,
			agreed_terms: {
				status: false,
				error: false
			}
		};
	},
	computed: {
		btnClass() {
			return this.form.subject.split(" ")[0].toLowerCase();
		},
		dropdownArr() {
			return this.dropdown.split(",");
		},
		formData() {
			return {
				data: Object.entries(this.form).map(([key, value]) => ({
					key,
					value
				}))
			};
		}
	},
	methods: {
		submit() {
			this.submitted = true;
			if (this.agreed_terms.status) {
				this.$validator.validateAll().then((isValid) => {
					if (isValid) {
						this.form.agreed = this.agreed_terms.status
							? "agreed"
							: "not agreed";
						this.send();
						this.agreed_terms.status = false;
					}
				});
			} else {
				this.agreed_terms.error = true;
			}
		},
		async send() {
			this.loading = true;

			let additionalData = {
				cid: document.querySelector("#cid_field").value,
				gclid: document.querySelector("#gclid_field").value
			};

			let form = { ...this.form, ...additionalData };

			await axios
				.post("https://mailer.signifly.com/api/klassik/mail", form)
				.then((response) => {
					this.submitted = false;
					this.success = true;
					this.loading = false;
					this.agreed_terms = {
						status: false,
						error: false
					};
					this.form = {
						url: window.location.href,
						subject: "default",
						message: "",
						name: "",
						email: ""
					};
				})
				.catch((e) => {
					this.error = true;
				});
		}
	}
};
</script>
<style lang="scss" scoped>
.select {
	position: relative;
	margin-bottom: 20px;
	width: fit-content;
	width: 100%;
	max-width: 270px;

	select {
		-webkit-appearance: none;
		-webkit-appearance: none;
		-moz-appearance: none;
		background-color: transparent;
		appearance: none;
		outline: none;
		border-radius: 0;
		width: 270px;
		max-width: 100%;
		margin-bottom: 0;
	}

	select::-ms-expand {
		display: none;
	}

	.arrow {
		position: absolute;
		right: 22px;
		top: 50%;
		transform: translateY(-50%);
		width: 15px;
		height: 14px;
		z-index: -1;

		&::v-deep svg {
			width: 15px;
			height: 14px;

			path {
				fill: $dark-grey;
			}
		}
	}

	.form-success,
	.form-error {
		margin-top: 8px;
	}
	.form-success {
		color: $vintage;
	}
}
.terms {
	@include terms;
}
</style>
